import { useMutation } from '@tanstack/react-query'

import { uploadCardTransactionEvidenceImage } from '@src/api'
import { DefaultApiUploadCardTransactionEvidenceImageRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useUploadCardTransactionEvidenceImage = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiUploadCardTransactionEvidenceImageRequest) =>
      uploadCardTransactionEvidenceImage(axiosInstance, params),
  })
}
